'use strict';

require('magnific-popup');

const $ = require('jquery');

function init() {
    const video = $('.js-popup-youtube');

    video.magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        mainClass: 'mfp-youtube',
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
            '<div class="mfp-close"></div>' +
            '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
            '</div>',
            patterns: {
                youtube: {
                  index: 'youtube.com/',
                  id: 'v=',
                  src: 'https://www.youtube.com/embed/%id%?autoplay=1'
                }
            }
        }
    });
}

module.exports = {
    init
};



// WEBPACK FOOTER //
// ./modules/popupVideo.js